import { render, staticRenderFns } from "./MenuParent.vue?vue&type=template&id=86ff1b54&scoped=true"
import script from "./MenuParent.vue?vue&type=script&lang=js"
export * from "./MenuParent.vue?vue&type=script&lang=js"
import style0 from "./MenuParent.vue?vue&type=style&index=0&id=86ff1b54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ff1b54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86ff1b54')) {
      api.createRecord('86ff1b54', component.options)
    } else {
      api.reload('86ff1b54', component.options)
    }
    module.hot.accept("./MenuParent.vue?vue&type=template&id=86ff1b54&scoped=true", function () {
      api.rerender('86ff1b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MenuParent.vue"
export default component.exports